/**
 * Badge component for showing unread update counts
 * - Red: Critical/High materiality events
 * - Yellow: Medium materiality events
 * - No badge: No unread or low only
 */

import { Materiality } from '../../types';

interface UpdateBadgeProps {
  count: number;
  highestMateriality?: Materiality;
  size?: 'sm' | 'md';
}

export function UpdateBadge({ count, highestMateriality, size = 'sm' }: UpdateBadgeProps) {
  if (count <= 0) return null;

  const isHighPriority = highestMateriality === 'critical' || highestMateriality === 'high';

  const bgColor = isHighPriority
    ? 'bg-red-500'
    : 'bg-amber-500';

  const sizeClasses = size === 'sm'
    ? 'min-w-[18px] h-[18px] text-[10px]'
    : 'min-w-[22px] h-[22px] text-xs';

  return (
    <span
      className={`${bgColor} ${sizeClasses} text-white font-medium rounded-full flex items-center justify-center px-1`}
      title={`${count} new update${count > 1 ? 's' : ''}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}

export default UpdateBadge;
